import useFormat from '@business/utils/hooks/useFormat';
import { Box, Flex, Stack } from '@chakra-ui/react';
import { Property } from '@data/models';
import styled from '@emotion/styled';
import Text from '@molecules/Text';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const Policies = ({ model }: { model: Property }) => {
  const { t } = useTranslation();
  const { currency } = useFormat();
  const lateCheckoutFee = useMemo(() => {
    if (!model || !model.policies || !model.policies.lateCheckout) return '0';
    if (model.policies.lateCheckoutType === 'percent') {
      return `${model.policies.lateCheckoutVal}%`;
    }
    return currency(model.policies.lateCheckoutVal);
  }, [model]);

  const policyItem = useCallback((label: string, value: string) => {
    return (
      <Flex>
        <Text mr="8px">•</Text>
        <Text weight="500">{label}:</Text>
        <Text ml="8px">{value}</Text>
      </Flex>
    );
  }, []);

  return (
    <Stack>
      <Text type="h2" mb="8px">
        {t('checkin-and-checkout-policies')}
      </Text>
      {policyItem('Check-in', model.policies.checkin)}
      {policyItem('Check-out', model.policies.checkout)}
      {model.policies.lateCheckout && (
        <>
          {policyItem('Late Checkout Hours', model.policies.lateCheckoutHour)}
          {policyItem('Late Checkout Fee', lateCheckoutFee)}
        </>
      )}
    </Stack>
  );
};

export default Policies;
